import getCacheFile from '../cache/cache_get';
import postCacheFile from '../cache/cache_post';

export const getCache = (url, missCallback) => {
  if (getCacheFile[url] !== undefined) {
    return { data: getCacheFile[url] };
  }

  return missCallback();
};

export const postCache = (labelId, missCallback) => {
  if (postCacheFile[labelId] !== undefined) {
    return { data: postCacheFile[labelId] };
  }

  return missCallback();
};
